/* eslint-disable @typescript-eslint/consistent-type-assertions */
/* eslint-disable no-param-reassign */
import { Throwable } from "@wss/error-tracking/throwable";
import { toError } from "@wss/error-tracking/utils";

export type FeatureFlag = {
  name: string;
  stringValue: string;
  boolValue: string;
};

export type CustomProps = {
  key: string;
  value: string;
};

export type FeatbitAbFeatureOption = {
  featureFlagName: string;
  customProps: CustomProps[];
  defaultValue: string;
};

async function getABFeatureFlag(
  requestBody: FeatbitAbFeatureOption,
  user: { sessionId?: string; emailAddress?: string }
): Promise<Throwable<FeatureFlag>> {
  try {
    const userProps = [
      { key: "SessionId", value: user.sessionId ?? "" },
      { key: "Email", value: user.emailAddress ?? "" },
    ] as CustomProps[];

    requestBody.customProps = requestBody.customProps
      ? requestBody.customProps.concat(userProps)
      : userProps;

    const response = await fetch("/api/getabfeatureflag/", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(requestBody),
    });
    if (!response.ok) {
      if (response.status >= 500) {
        throw new Error(
          `Fetch for Featbit Feature: ${requestBody.featureFlagName} from /api/getabfeatureflag failed with status ${response.status}`
        );
      }
      return {
        isError: false,
        value: {
          name: requestBody.featureFlagName,
          stringValue: requestBody.defaultValue,
        } as FeatureFlag,
      };
    }
    const result = await response.json<FeatureFlag>();
    return { isError: false, value: result };
  } catch (error) {
    return { isError: true, error: toError(error) };
  }
}

export default getABFeatureFlag;
